<script>
 import 'whatwg-fetch'
 import 'promise-polyfill/src/polyfill'
 import { onMount } from 'svelte'
 import { get } from 'svelte/store'
 import { publications, cart_totals } from './store.js'

 onMount(async function() {
   if ( $publications.length <= 0 ) {
     cart_totals.set(0)
     const response = await fetch('/api/v1/publications')
     const data = await response.json()
     publications.set(data.publications)

     $publications.forEach( function(pub) {
       cart_totals.update(function(n) { return n + Number(pub.quantity) })
     })
   }
 })

 function increment(pubs, index) {
   pubs[index].quantity = Number(pubs[index].quantity) + 1
   publications.set(pubs)
   cart_totals.update(function(n) { return n + 1 })
 }

 function decrement(pubs, index) {
   if ( pubs[index].quantity > 0 ) {
     pubs[index].quantity = Number(pubs[index].quantity) - 1
     publications.set(pubs)
     cart_totals.update(function(n) { return n - 1})
   }
 }

</script>

<svelte:head>
</svelte:head>

<div class="shopping-cart">
  {#if $cart_totals > 0 }
    <a class="button" href="/resources/publications-cart">
      <i class="fa fa-shopping-cart shop-icon"></i>
      Check Out ({ $cart_totals })
    </a>
  {:else}
    <i class="fa fa-shopping-cart shop-icon"></i>
    Cart is Empty
  {/if}
</div>

<div class="shop-container">
  {#each $publications as pub, i}
    <div class="shop-item">
      <div class="shop-row"> <img src="{pub.image}" alt="{pub.name}" /></div>
      <div class="shop-row text-row">
        <p class="item-name">
          {pub.name}
        </p>
      </div>
      <div class="shop-row"><p class="item-price">${pub.price}</p></div>
      {#if pub.out_of_stock == 1}
        <div class="show-row" style="text-align:center">
          {@html pub.out_of_stock_message}
        </div>
      {:else}
        {#if pub.quantity == 0}
          <div class="shop-row">
            <button on:click={function() {increment($publications, i)}}>
              Add To Cart
            </button>
          </div>
        {:else}
          <div class="shop-row">
            <button on:click={function() {decrement($publications, i)}} class="round-button">-</button>
            <span class="quantity">Quantity: {pub.quantity}</span>
            <button on:click={function() {increment($publications, i)}} class="round-button">+</button>
          </div>
        {/if}
      {/if}
    </div>
  {/each}
</div>

<div class="shopping-cart">
  {#if $cart_totals > 0 }
    <a class="button" href="/resources/publications-cart">
      <i class="fa fa-shopping-cart shop-icon"></i>
      Check Out ({ $cart_totals })
    </a>
  {:else}
    <i class="fa fa-shopping-cart shop-icon"></i>
    Cart is Empty
  {/if}
</div>

<style>
 .shopping-cart {
   display: block;
   text-align: right;
 }

 .shop-container {
   display: flex;
   flex-wrap: wrap;
 }

 .shop-item {
   -ms-flex: 1 1 33%;
   flex: 1 1 33%;
   padding: 40px 20px;
   display: grid;
   -ms-grid-columns: auto;
   grid-template-columns: auto;
 }

 .shop-row {
   text-align: center;
 }

 .shop-row.text-row {
   min-height: 40px;
 }

 .shop-item img {
   width: auto;
   height: 350px;
   display: unset;
   margin: 10px auto;
 }

 .shop-item .item-name {
   font-weight: bold;
   color: #1f5733;
 }

 .shop-item .item-price {
   font-weight: bold;
   font-style: italic;
   padding: 10px;
   color: #1f5733
 }

 .shop-item button, .button {
   transition-duration: 0.4s;
   border: none;
   padding: 15px 32px;
   text-align: center;
   text-decoration: none;
   display: inline-block;
   background-color: #1f5733;
   color: white;
 }

 .shop-item button:hover, .button:hover {
   background-color: #12311d;
 }

 .shop-item button.round-button {
   border-radius: 50%;
   padding: 20px;
   line-height: 0.5rem;
   font-size:1.5rem;
 }

 .shop-item .quantity {
   padding: 10px 20px;
   font-weight: bold;
 }

</style>
